export const IndeCXRadiologista = {
  key: '5f08a17de1db8a43195b1396',
  action: '6463c910e71a35001a842045',
  indicators: { test: 'test' }
}

export const IndeCXCliente = {
  key: '5f08a17de1db8a43195b1396',
  action: '64d4f3cebca559002da9e707',
  indicators: { test: 'test' }
}

export const HuggyConfig = {
  defaultCountry: '+55',
  uuid: '742b6c16-0035-4a55-817b-817e010f60da',
  company: '327986',
  contextID: 'c1f1b0b26b2025654b5f4089bfd8b09b'
}
